var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMxn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_600_12143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9664,
    cy: 23.067,
    r: 22.65,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_600_12143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.5498,
    y: 0.416992,
    width: 10.0667,
    height: 45.3,
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3828,
    y: 0.416992,
    width: 25.1667,
    height: 45.3,
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.316406,
    y: 0.416992,
    width: 10.0667,
    height: 45.3,
    fill: "#008259"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8971 22.7116C11.7297 23.4861 11.6416 24.2902 11.6416 25.1147C11.6416 31.3694 16.712 36.4397 22.9666 36.4397C29.2212 36.4397 34.2916 31.3694 34.2916 25.1147C34.2916 24.2726 34.1997 23.4519 34.0253 22.6621L30.4621 24.203C30.4981 24.5019 30.5166 24.8061 30.5166 25.1147C30.5166 29.2845 27.1364 32.6647 22.9666 32.6647C18.7969 32.6647 15.4166 29.2845 15.4166 25.1147C15.4166 24.8239 15.433 24.5369 15.4651 24.2545L11.8971 22.7116Z",
    fill: "#009B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2445 18.0336L28.7247 20.5752C29.0812 21.1873 28.8775 21.9724 28.2683 22.334L27.9728 21.8361C27.9535 21.9451 27.9304 22.053 27.9035 22.1594L28.0866 22.468C28.4472 23.0757 28.2469 23.8607 27.6392 24.2214L27.245 23.5571C27.218 23.5929 27.1903 23.6282 27.1619 23.663C27.475 24.2614 27.2683 25.0069 26.6806 25.3557L26.1735 24.5011C26.1728 24.5015 26.1721 24.5019 26.1715 24.5023L26.0743 24.3339L23.944 20.7443L24.3567 23.9541L27.2446 26.8421H21.8773C20.6249 26.8421 19.5631 25.9211 19.386 24.6813L18.8588 20.9908L16.9838 21.5417L16.6291 20.3344C16.2373 19.0009 17.0007 17.6022 18.3343 17.2104L19.5416 16.8557C20.6204 16.5387 21.742 16.9778 22.3384 17.8633L22.2113 17.6431C21.8638 17.0413 22.0668 16.2419 22.7399 16.0689C24.4498 15.6296 25.9552 16.4864 27.2445 18.0336Z",
    fill: "#936846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 20.2358L16.9839 21.5417L18.8768 20.9856L16.6003 20.2358Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9911 24.8758C15.5277 22.354 14.0593 21.0511 13.5322 20.7217L14.5326 19.1211C15.3912 19.6577 17.054 21.2237 18.6236 23.9283L16.9911 24.8758ZM22.3198 29.8667C20.6239 29.7216 18.9276 28.823 17.8959 26.6122L19.6064 25.814C20.3363 27.3782 21.4188 27.8952 22.4807 27.9861C23.6188 28.0834 24.7978 27.6864 25.5239 27.278L26.4492 28.9231C25.4975 29.4585 23.9396 30.0053 22.3198 29.8667Z",
    fill: "#008259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxn);
export default __webpack_public_path__ + "static/media/MXN.96aad3ed9068ffed5cc378336b4e6797.svg";
export { ForwardRef as ReactComponent };